import { useAtom } from '@reatom/npm-react'
import * as DateF from 'date-fns'
import { Trans } from 'react-i18next'
import styled, { css } from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { useCurrencyExpirationLeft } from '@root/entities/premium'
import { DATE_FORMAT } from '@root/shared'
import { mediaMinTablet } from '@root/shared/ui-kit'

import { PremiumCurrencyDetailsBooster } from './premium-currency-details-boosters'

import type { CurrencyModel } from '@root/entities/currency'
import type { PremiumMetaModel } from '@root/entities/premium'

type Props = {
  currency: CurrencyModel
  premiumInfo: PremiumMetaModel | undefined
}

export const PremiumCurrencyDetailsPremium: React.FC<Props> = ({
  premiumInfo,
  currency,
}) => {
  if (!premiumInfo) {
    return undefined
  }

  return (
    <PremiumCurrencyDetailsPremium_
      premiumInfo={premiumInfo}
      currency={currency}
    />
  )
}

export const PremiumCurrencyDetailsPremium_ = ({
  premiumInfo,
  currency,
}: {
  premiumInfo: PremiumMetaModel
  currency: CurrencyModel
}) => {
  const { formatExpirationLeft } = useCurrencyExpirationLeft()
  const [expireAt] = useAtom(premiumInfo.expiresAt)
  const [boosters] = useAtom(premiumInfo.boosters)

  const expirationLeft = formatExpirationLeft(currency, expireAt)

  return (
    <Root>
      <Header>
        <TimeLeft>
          <Trans
            i18nKey="premium.purchased.date-due"
            components={[<span key={0} />]}
            values={{
              date: DateF.format(expireAt, DATE_FORMAT.dd_MM_yy),
            }}
          />
        </TimeLeft>
        {expirationLeft ? <DaysLeft>{expirationLeft}</DaysLeft> : undefined}
      </Header>
      <Footer>
        <PremiumCurrencyDetailsBooster total={boosters} />
      </Footer>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 10px;
  margin: auto;
  align-items: center;
  justify-content: center;
  text-align: center;
`
const Header = styled.div`
  display: flex;
  column-gap: 8px;
  align-items: baseline;
  justify-content: center;
  flex-wrap: wrap;
`
const Footer = styled.div`
  display: grid;
  justify-content: center;
`

const TimeLeft = styled.p`
  color: var(--text-12);

  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;

  text-align: center;

  span {
    background: linear-gradient(
      92deg,
      var(--subscriptionGradientFrom-9) 1.37%,
      var(--subscriptionGradientTo-9) 52.8%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  ${mediaMinTablet(css`
    font-size: var(--typography-body-1-bold-font-size);
    line-height: var(--typography-body-1-bold-line-height);
    font-weight: var(--typography-body-1-bold-font-weight);
  `)}
`

export const DaysLeft = styled(Typography).attrs({
  variant: 'body2-bold',
  component: 'span',
})`
  color: var(--textA-9);
`
